var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmotionalHealth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4383 52.0971C44.0524 52.4631 43.4476 52.4631 43.0617 52.0971L34.3452 43.8277C33.7602 43.2727 33.2961 42.6138 32.9795 41.8887C32.663 41.1636 32.5 40.3864 32.5 39.6016C32.5 38.8167 32.663 38.0396 32.9795 37.3144C33.2961 36.5893 33.7602 35.9305 34.3452 35.3755C34.9302 34.8205 35.6246 34.3803 36.389 34.0799C37.1533 33.7796 37.9725 33.625 38.7998 33.625C39.6271 33.625 40.4463 33.7796 41.2106 34.0799C41.9749 34.3803 42.6694 34.8205 43.2544 35.3755V35.3755C43.5322 35.6391 43.9678 35.6391 44.2456 35.3755V35.3755C44.8306 34.8205 45.5251 34.3803 46.2894 34.0799C47.0537 33.7796 47.8729 33.625 48.7002 33.625C49.5275 33.625 50.3467 33.7796 51.111 34.0799C51.8754 34.3803 52.5698 34.8205 53.1548 35.3755C53.7398 35.9305 54.2039 36.5893 54.5205 37.3144C54.8371 38.0396 55 38.8167 55 39.6016C55 40.3864 54.8371 41.1636 54.5205 41.8887C54.2039 42.6138 53.7398 43.2727 53.1548 43.8277L44.4383 52.0971Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 14.5V5C15.625 2.79086 17.4159 1 19.625 1H35.25C37.4591 1 39.25 2.79086 39.25 5V14.5",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 39.25L5 39.25C2.79086 39.25 1 37.4591 1 35.25L0.999999 19.625C0.999999 17.4159 2.79086 15.625 5 15.625L14.5 15.625",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 40.375L15.625 49.875C15.625 52.0841 17.4159 53.875 19.625 53.875L35.25 53.875C37.4591 53.875 39.25 52.0841 39.25 49.875L39.25 48.25",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 40.375V39.25H14.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 15.625L15.625 15.625L15.625 14.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.25 14.5L39.25 15.625L40.375 15.625",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.375 15.625L49.875 15.625C52.0841 15.625 53.875 17.4159 53.875 19.625L53.875 28.315L53.875 35.875",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotionalHealth);
export default __webpack_public_path__ + "static/media/emotionalHealth.85e82a58.svg";
export { ForwardRef as ReactComponent };